/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridCellPosition = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridCellPosition, _super);
    function GridCellPosition() {
        var _this = _super.call(this) || this;
        _this.a = 0;
        _this.c = null;
        var self_ = _this;
        self_.___mustPassByValue = true;
        return _this;
    }
    Object.defineProperty(GridCellPosition.prototype, "b", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            this.a = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridCellPosition.prototype, "d", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
        },
        enumerable: true,
        configurable: true
    });
    GridCellPosition.$t = markType(GridCellPosition, 'GridCellPosition');
    return GridCellPosition;
}(Base));
export { GridCellPosition };
//# sourceMappingURL=GridCellPosition.js.map
